var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_268_798",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6589 9.20836L6.35052 9.20836L10.4172 5.34503C10.7422 5.03628 10.7422 4.52961 10.4172 4.22086C10.0922 3.91211 9.56719 3.91211 9.24219 4.22086L3.75052 9.43794C3.42552 9.74669 3.42552 10.2454 3.75052 10.5542L9.23385 15.7792C9.38955 15.9274 9.60092 16.0107 9.82135 16.0107C10.0418 16.0107 10.2532 15.9274 10.4089 15.7792C10.7339 15.4704 10.7339 14.9717 10.4089 14.6629L6.35052 10.7917L15.6589 10.7917C16.1172 10.7917 16.4922 10.4354 16.4922 10C16.4922 9.56461 16.1172 9.20836 15.6589 9.20836Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_268_798)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19.5,
    width: 20,
    height: 19,
    transform: "rotate(-180 20 19.5)",
    fill: "#32A89C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.100cfda5474ba14382b7bf4265f1a9e1.svg";
export { ForwardRef as ReactComponent };